import { fetchWithToken } from '../../../api/apiutils';

export const getCustomers = async (text = '') => {
  const params = new URLSearchParams({ Text: text, Page: 1, PageLimit: 10 });
  const res = await fetchWithToken(`/api/customers?${params.toString()}`);
  if (!res.ok) throw new Error('Ошибка загрузки заказчиков');
  const data = await res.json();
  return data.data || [];
};

export const getOked = async (text = '') => {
  const params = new URLSearchParams({ Text: text, Page: 1, PageLimit: 10 });
  const res = await fetchWithToken(`/api/customers/oked?${params.toString()}`);
  if (!res.ok) throw new Error('Ошибка загрузки ОКЭД');
  const data = await res.json();
  return data.data || [];
};
